import Collection from '../../Models/Collection';
import Cadence from '@models/Cadence';
import type { ReduxAction } from '../../types';
import Occasion from '@support/Occasion';

// collection of cadences is keyed by contactID
export interface ReconnectState {
  collection: Collection<Cadence>;
}

const initialReconnectState = {
  collection: new Collection<Cadence>(),
};

export function reconnectReducer(
  state: ReconnectState = initialReconnectState,
  { type, payload }: ReduxAction,
) {
  const contactID = String(payload?.contactID);

  switch (type) {
    case 'FETCH_RECONNECT_CADENCE_REQUESTED':
      return {
        collection: state.collection.copyWith({
          items: state.collection.items.update(
            contactID,
            new Cadence({ isFetching: true }),
            (cadence) => cadence.copyWith({ isFetching: true }),
          ),
        }),
      };

    case 'FETCH_RECONNECT_CADENCE_SUCCEEDED':
    case 'CREATE_RECONNECT_CADENCE_SUCCEEDED':
      return {
        collection: state.collection.copyWith({
          items: state.collection.items.update(contactID, (cadence) =>
            cadence.copyWith({
              ...payload.cadence,
              isFetching: false,
              updated: new Occasion(),
            }),
          ),
        }),
      };

    case 'CREATE_RECONNECT_CADENCE_REQUESTED':
      return {
        collection: state.collection.copyWith({
          items: state.collection.items.update(
            contactID,
            new Cadence({ isFetching: true }),
            (cadence) => cadence.copyWith({ ...payload.cadence, isFetching: true }),
          ),
        }),
      };

    case 'DELETE_RECONNECT_CADENCE_REQUESTED':
      return {
        collection: state.collection.copyWith({
          items: state.collection.items.update(
            contactID,
            new Cadence({ type: 'none' }),
            (cadence) => cadence.copyWith({ type: 'none' }),
          ),
        }),
      };

    case 'FETCH_RECONNECT_CADENCE_FAILED':
    case 'CREATE_RECONNECT_CADENCE_FAILED':
      return {
        collection: state.collection.copyWith({
          items: state.collection.items.update(contactID, (cadence) =>
            cadence.copyWith({ error: true, isFetching: false }),
          ),
        }),
      };

    // Action types not implemented:
    case 'DELETE_RECONNECT_CADENCE_SUCCEEDED':
    case 'DELETE_RECONNECT_CADENCE_FAILED':
    default:
      return state;
  }
}
